module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  In progress...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2893aa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/home.vue
// module id = 223
// module chunks = 1